import styled from 'styled-components';

import { LegacyTooltip } from 'components/LegacyTooltip';
import { cssBreakpoints } from 'theme/theme';

export const StyledTooltip = styled(LegacyTooltip)`
  bottom: 2px;
  display: inline-block;
  margin-left: 6px;
  position: relative;
`;

export const MainChartLegendContainer = styled.div`
  display: flex;
  margin-bottom: 30px;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    justify-content: end;
  }
`;
